import { mapValues } from 'lodash'

export function convertToFieldType(fieldType, value) {
  switch (fieldType) {
    case 'number': {
      return Number(value)
    }

    case 'boolean': {
      if (typeof value === 'string') {
        return value.toLowerCase() === 'true' || value.toLowerCase() === '1'
      }
      break
    }

    case 'text': {
      if (value != null && typeof value.toString === 'function') {
        return value.toString()
      }
      break
    }
  }

  return value
}

export function ensureSchemaTypes(getFieldType, record) {
  return mapValues(record, (value, fieldName) =>
    getFieldType(fieldName)
      .map(fieldType => convertToFieldType(fieldType, value))
      .getOrElse(value),
  )
}
